<template>
  <d-card class="card-small">

    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
      <div class="block-handle"></div>
    </d-card-header>

    <d-card-body class="p-0">

      <!-- Top Referrals List Group -->
      <d-list-group flush class="list-group-small">
        <d-list-group-item v-for="(item, idx) in referralData" :key="idx" class="d-flex px-3">
          <d-link class="link row-name">
            <span class="text-semibold text-fiord-blue">{{ item.reference_no }} </span>
            <span class="text-semibold text-fiord-blue"> {{ item.customer_name }} </span>
          </d-link>
          <span class="ml-auto row-status text-right text-semibold text-reagent-gray"> {{ status[item.status] }}</span>
          <span class="ml-5 row-total text-right text-semibold text-reagent-gray">{{ item.total }}</span>
        </d-list-group-item>
        <d-list-group-item v-if="referralData.length === 0"  class="d-flex px-3 no-content">
          {{ $t('shared.dashboard.noResults') }}
        </d-list-group-item>
      </d-list-group>

    </d-card-body>

    <d-card-footer class="border-top">
      <d-row>

        <!-- Time Frame -->
        <d-col>
          <d-select size="sm" v-model="filter" style="max-width: 150px;" :options="options">
          </d-select>
        </d-col>

        <!-- View Full Report -->
        <d-col class="text-right view-report">
          <d-link class="link">{{ $t('shared.dashboard.viewAll') }}</d-link>
        </d-col>

      </d-row>
    </d-card-footer>

  </d-card>
</template>

<script>

export default {
  name: 'dashboard-last-register',
  data() {
    return {
      filter: 'last-week',
      referralData: [],
    };
  },
  computed: {
    title() {
      return this.$t('shared.dashboard.lastRegisters.title');
    },
    options() {
      return [
        {
          value: 'last-week',
          text: this.$t('shared.dashboard.lastRegisters.filters.lastWeek'),
        },
        {
          value: 'today',
          text: this.$t('shared.dashboard.lastRegisters.filters.today'),
        },
        {
          value: 'last-month',
          text: this.$t('shared.dashboard.lastRegisters.filters.lastMonth'),
        },
        {
          value: 'last-year',
          text: this.$t('shared.dashboard.lastRegisters.filters.lastYear'),
        },
      ];
    },
    status() {
      return {
        open: this.$t('shared.dashboard.status.open'),
        pending: this.$t('shared.dashboard.status.pending'),
        approved: this.$t('shared.dashboard.status.approved'),
        canceled: this.$t('shared.dashboard.status.canceled'),
        closed: this.$t('shared.dashboard.status.closed'),
      };
    },
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  cursor: pointer;
}
.row-total,
.row-status {
  width: 15%;
}
.row-name {
  width: 70%;
}
</style>
